import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { DynamicForm } from '../../DynamicForm';
import * as v from '../../../helpers/validation';
import classnames from 'classnames';

// SERVICES
import { putClientUser, getClientUserById, getClientList } from '../../../services';

const styles = {
  gridHeader: {
    marginBottom: 0,
    paddingBottom: 0,
  },
};

export const ClientUsersDetail = withStyles(styles)(props => {
  const { match, setPageTitle, classes } = props;
  const { userId } = match.params;
  const [formError, setFormError] = useState(null);
  const [clientUserFormData, setClientUserFormData] = useState(null);
  const [clientList, setClientList] = useState([]);

  useEffect(() => {
    getClientListAsync();
  }, []);

  const getClientListAsync = async () => {
    let clients = await getClientList();
    clients = clients.map(c => {
      return {
        value: c.id,
        label: `${c.name} ${c.code && `(${c.code})`}`,
      };
    });
    setClientList(clients);
  };

  useEffect(() => {
    clientUserFormData && clientUserFormData.fname && clientUserFormData.lname
      ? setPageTitle(`Edit CLIENT: ${clientUserFormData.fname} ${clientUserFormData.lname}`)
      : setPageTitle(`Edit CLIENT`);
  }, [clientUserFormData]);

  useEffect(() => {
    const getClientUserByIdAsync = async () => {
      try {
        const clientUserObj = await getClientUserById(userId);
        setClientUserFormData(clientUserObj);
      } catch (error) {
        console.log(error);
        setFormError(error);
      }
    };

    getClientUserByIdAsync();
  }, []);

  const clientUserInputs = [
    {
      inputType: 'gridcontainer',
      children: [
        {
          inputType: 'griditem',
          children: [
            {
              inputType: 'select',
              field: 'clientId',
              label: 'Client',
              validate: [v.required()],
              options: clientList,
            },
            {
              inputType: 'text',
              field: 'email',
              label: 'Email',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'userName',
              label: 'Username',
              disabled: true,
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'fname',
              label: 'First Name',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'mname',
              label: 'Middle Name',
              validate: [],
            },
            {
              inputType: 'text',
              field: 'lname',
              label: 'Last Name',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'title',
              label: 'Title',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'company',
              label: 'Company',
              validate: [v.required()],
            },
          ],
        },
      ],
    },
  ];

  return (
    <div className={classnames('grid-container')}>
      <DynamicForm
        inputs={clientUserInputs}
        data={clientUserFormData}
        mode={'EDIT'}
        onSave={putClientUser}
        redirectOnSuccess={'/users/client'}
      />
      <div>{formError}</div>
    </div>
  );
});
